import request from '@/utils/request'
import storage from "@/utils/storage"
/*登录*/
async function login() {
    return request({
        url: "/api/login/sso",
        method: 'post',
        data: {
            ticket: storage.get('robot_app_ST'),
            serviceUrl: process.env.VUE_APP_SERVICE_URL
        },
        showLoading: false
    })
}

/*根据所选标题查询回复详情*/

async function detailProduct(data) {
    return request({
        url: `/api/ink-stone/detail`,
        method: 'post',
        data: data,
        showLoading: false
    })
}

export default {
    login,
    detailProduct
}
